
import $ from 'jquery';


export default () => {
    $('#hamburger-toggle').on('click', function () {
        $(this).toggleClass('active');
        $('#overlay').toggleClass('open');
        $('body').toggleClass('overlay-open');
    });
};



// WEBPACK FOOTER //
// ../views/components/hamburger/hamburger.js